<template>
  <div class="sub-section">
    <template v-if="showModeSelect">
      <b-field
        class="input-field"
        label="Row filters">
        <singleselect
          v-model="filterMode"
          :options="filterModeOptions"
          :return-as-object="false"
          :enable-search="false"
          :append-to-body="true"
          label="label"
          track-by="key"
          header-placeholder="Select how row filters apply" />
      </b-field>

      <div
        v-if="rowFilters.length"
        class="row-filters">
        <span class="row-filters-label">{{ rowFiltersLabel }}</span>
        <b-tag
          v-for="(filter, i) in rowFilters"
          :key="i"
          class="row-filters-tag"
          type="is-light">
          {{ filterLabel(filter) }}
        </b-tag>
      </div>
    </template>

    <b-field
      v-if="showFilterEditor"
      class="input-field"
      label="">
      <FilterConfigListEditor
        v-model="inputs"
        :errors="errors"
        :default-time-range="defaultTimeRange"
        :default-time-range-label="defaultTimeRangeLabel" />
    </b-field>
  </div>
</template>

<script>

  import FilterConfigListEditor from '@/components/reports/config/modules/common/FilterConfigListEditor'
  import singleselect from '@/components/ui/singleselect.vue'

  export default {
    name: 'FiltersTab',
    components: {
      FilterConfigListEditor,
      singleselect,
    },
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      errors: {
        type: Array,
        default: () => [],
      },
      defaultTimeRange: {
        type: Object,
        default: null,
      },
      defaultTimeRangeLabel: {
        type: String,
        default: 'Use measure default',
      },
      // Set where this config sits under another whose filters it can take --
      // a tracker total under its row. Absent elsewhere, so every other
      // caller keeps a plain filter list.
      mode: {
        type: String,
        default: null,
      },
      rowFilters: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        filterModeOptions: [
          { key: 'inherit', label: 'Use the row\'s filters', },
          { key: 'extend', label: 'Use the row\'s filters, and add to them', },
          { key: 'replace', label: 'Ignore the row\'s filters', },
        ],
      }
    },
    computed: {
      showModeSelect () {
        return this.mode !== null
      },
      // Inherit carries none of its own, so there is nothing to edit.
      showFilterEditor () {
        return !this.showModeSelect || this.mode !== 'inherit'
      },
      rowFiltersLabel () {
        return this.mode === 'replace' ? 'Ignoring:' : 'From the row:'
      },
      filterMode: {
        get () {
          return this.mode
        },
        set (mode) {
          this.$emit('update:mode', mode)
        },
      },
      inputs: {
        get () {
          return this.value || []
        },
        set (value) {
          this.$emit('input', value ? value : [])
        },
      },
    },
    methods: {
      filterLabel (filterConfig) {
        const filter = filterConfig?.filter
        return filter?.dimension?.name
          || filter?.dimension?.key
          || filter?.name
          || filter?.key
          || 'Filter'
      },
    },
  }
</script>

<style lang="scss" scoped>
.row-filters {
  margin: -4px 0 12px;

  .row-filters-label {
    font-size: 12px;
    color: #7a7a7a;
    margin-right: 6px;
  }

  .row-filters-tag {
    margin-right: 4px;
  }
}

.sub-section {
  padding: 16px;
  overflow: auto;
}
</style>
